import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import dynamic from "next/dynamic";
export function StoryblokIcon(param) {
    var iconName = param.iconName, _color = param.color, color = _color === void 0 ? "monochrome-white" : _color, _size = param.size, size = _size === void 0 ? 24 : _size;
    var Icon = dynamic({
        loader: /*#__PURE__*/ _async_to_generator(function() {
            var isIconName, icons, Icon;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isIconName = function isIconName(input) {
                            return input in icons;
                        };
                        return [
                            4,
                            import("@cinch-nx/design-system-icons")
                        ];
                    case 1:
                        icons = _state.sent();
                        if (!isIconName(iconName)) {
                            return [
                                2,
                                icons.BinIcon
                            ];
                        }
                        Icon = icons[iconName];
                        return [
                            2,
                            Icon
                        ];
                }
            });
        }),
        ssr: true
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    require.resolveWeak("@cinch-nx/design-system-icons")
                ];
            }
        }
    });
    return /*#__PURE__*/ _jsx(Icon, {
        color: color,
        size: size
    });
}
